export function getToken() {
  return sessionStorage.getItem("token"); 
}
  
export function setToken(token) {
  return sessionStorage.setItem("token", token); 
}
  
export function removeToken() {
  return sessionStorage.removeItem("token");
}
export function getUserInfo() {
  return sessionStorage.getItem("userInfo"); ;
}
  
export function setUserInfo(userInfo) {
  return sessionStorage.setItem("userInfo", userInfo);
}
  
export function removeUserInfo() {
  return sessionStorage.removeItem("userInfo");
}
export function getAuth() {
  return sessionStorage.getItem("Auth");
}
  
export function setAuth(Auth) {
  return sessionStorage.setItem("Auth", Auth);
}
  
export function removeAuth() {
  return sessionStorage.removeItem("Auth");
}
export function getPartyInfo() {
  return sessionStorage.getItem("PartyInfo");
}
export function setPartyInfo(PartyInfo) {
  return sessionStorage.setItem("PartyInfo", PartyInfo);
}
export function getTenantId() {
  return sessionStorage.getItem("TenantId");
}
  
export function setTenantId(TenantId) {
  return sessionStorage.setItem("TenantId", TenantId);
}

export function getIndex() {
  return sessionStorage.getItem("Index");
}
  
export function setIndex(Index) {
  return sessionStorage.setItem("Index", Index);
}

export function setUserRole(UserRole) {
  return sessionStorage.setItem("UserRole", UserRole);
}

export function getUserRole() {
  return sessionStorage.getItem("UserRole");
}

export function gotoMarket() {
  if (process.env.VUE_APP_USE_ATMOS === 'true') {
    gotoAtmos()
    return
  }

  const token = window.btoa(getToken())
  const userInfo = JSON.parse(getUserInfo())
  const username = userInfo.username || ''
  const realname = userInfo.realname || ''
  const avatar = userInfo.avatar || ''
  const ssoUrl = process.env.VUE_APP_SSO_URL
  const href = window.btoa(window.location.href)
  
  window.location.href = `${ssoUrl}?authinfo=${token}&username=${username}&realname=${realname}&avatar=${avatar}&source_ep=${href}`
}

export function gotoAtmos() {
  window.open(process.env.VUE_APP_ATMOS_URL, '_blank')
}